var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronSmallUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 8,
  fill: "none",
  viewBox: "0 0 8 8"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1C1C1A",
  fillRule: "evenodd",
  d: "M7.847 6.207a.5.5 0 0 1-.707 0L3.993 3.061.847 6.207A.5.5 0 0 1 .14 5.5l3.853-3.854L7.847 5.5a.5.5 0 0 1 0 .707",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h8v8H0z"
})))));
export { SvgChevronSmallUp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNzQ0Xzk0MzkpIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03Ljg0NzAyIDYuMjA3MTFDNy42NTE3NiA2LjQwMjM3IDcuMzM1MTggNi40MDIzNyA3LjEzOTkyIDYuMjA3MTFMMy45OTM0NyAzLjA2MDY2TDAuODQ3MDIzIDYuMjA3MTFDMC42NTE3NjEgNi40MDIzNyAwLjMzNTE3OCA2LjQwMjM3IDAuMTM5OTE2IDYuMjA3MTFDLTAuMDU1MzQ2NSA2LjAxMTg0IC0wLjA1NTM0NjQgNS42OTUyNiAwLjEzOTkxNiA1LjVMMy45OTM0NyAxLjY0NjQ1TDcuODQ3MDIgNS41QzguMDQyMjggNS42OTUyNiA4LjA0MjI4IDYuMDExODUgNy44NDcwMiA2LjIwNzExWiIgZmlsbD0iIzFDMUMxQSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzc0NF85NDM5Ij4KPHJlY3Qgd2lkdGg9IjgiIGhlaWdodD0iOCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";